import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

const PARTNERS = [
  { name: "Santander Bank", logo: "/partners/santander.png" },
  { name: "Bank11", logo: "/partners/bank11.png" },
  { name: "Creditreform", logo: "/partners/creditreform.png" },
];

export default function Partners() {
  const { t } = useLang();
  return (
    <section id="partners" className="py-28 px-6 md:px-10 bg-obsidian-surface border-t border-white/10" data-testid="partners-section">
      <div className="max-w-[1600px] mx-auto text-center">
        <p className="text-brand-bright text-xs uppercase tracking-[0.3em] mb-4">{t.partners.overline}</p>
        <h2 className="font-heading font-black uppercase tracking-tighter text-white text-4xl md:text-6xl mb-5">
          {t.partners.title}
        </h2>
        <p className="text-zinc-400 max-w-xl mx-auto mb-16">{t.partners.subtitle}</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PARTNERS.map((p, idx) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="group flex items-center justify-center bg-white py-12 px-8 border border-white/10 hover:shadow-[0_20px_50px_-20px_rgba(46,224,107,0.35)] hover:-translate-y-1 transition-all duration-500"
              data-testid={`partner-${idx}`}
            >
              <img
                src={p.logo}
                alt={p.name}
                className="h-10 md:h-12 w-auto object-contain"
                loading="lazy"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
